import React, { useContext } from 'react';
import { FormContext } from 'contexts/FormContext';

import { AuPageAlert } from 'components/DTA';

import styles from './FormAlert.module.scss';

interface Props {
  htmlFor: string;
}

/**
 * DEFAULT
 * Form alert
 */
const FormAlert: React.FC<Props> = ({ htmlFor }) => {
  const { formAlert } = useContext(FormContext);

  if (!formAlert) {
    return null;
  }

  return (<>{formAlert.map((alert, i) => <AuPageAlert key={'alert' + i} className={styles.formAlert} {...alert} htmlFor={htmlFor} />)}</>);

};

export default FormAlert;
